import { ReactNode, RefObject } from "react";
import IComponentButton from "react-common-components/dist/components/Button/interface";
import IBaseDTO from "src/Interfaces/baseDTO";
import IGroupersDTO from "src/Interfaces/groupersDTO";
import { IListActions } from "src/pages/Actions/Panel/interface";

export interface IFiltersMeetingPanel{
    filter: string;
    responsible?: string;
    participants?: string;
    meetingType?:string;
    meetingRoom?:string;
    startDate?: string;
    endDate?: string;
    tags?: string;
    map?: string;
    meetingId?: string;
}

export interface IGroupersMeeting extends IGroupersDTO<IGroupersMeeting>{
    id2?:string;
    finished:number;
    notFinished:number;
    image?: string;
    imageName?: string;
}

export interface IMeetingListDTO{
    ara001Id :number;
    ara001Assunto :string;
    ara001Dthrinicio :Date;
    ara001Dthrfim :Date;
    ara001Finalizada :string;
    ara001Linkexterno? :string;
    ara001Diasfinalizar? :string;
    ara001Efa005Id :string
    ara001Efa005Nome :string;
    ara001Efa005Imagem? :string;
    taa008Descricao? :string;
    taa010Descricao? :string;
    participantCanAttend?:boolean;
    isParticipant?:boolean;
}

export interface IResourceDTO{
    ara001Assunto :string;
    ara001Dthrinicio :Date;
    ara001Dthrfim :Date;
    taa008Descricao? :string;
    efa005Nome? :string;
}

export interface IMeetingFormDTO extends IMeetingListDTO, IBaseDTO{
    ara001Taa008Id :string
    ara001Pauta :string
    ara001Ata?:string
    ara001Mea001Id?:string
    ara001Taa010Id?:string
    ara001Diasfinalizar?:string
    mea001Nome?:string;
    participants:Array<IMeetingParticipant>
    tags:Array<number>
    attachments?:File[];
    actions?:IListActions[];
}

export interface IMeetingParticipant {
    id :string;
    ara002Id:number;
    ara002Efa005Id?:string;
    ara002Presente :string;
    ara002Acordoata :string;
    ara002Comentario :string;
    ara002Participante?:string;
    efa005Nome?:string;
    typeParticipant:"user"|"person";
    showExtra:Boolean;
}

export interface IParticipantInfo {
    ara001Id :number;
    ara001Ata :string;
    ara002Id:number;
    ara002Efa005Id?:string;
    ara002Presente :string;
    ara002Acordoata :string;
    ara002Comentario :string;
}

export enum MeetingGroupers{
    MEETING_TYPE = "1",
    RESPONSIBLE = "2",
    MEETING_ROOM = "3",
    PARTICIPANT = "4",
    MAP = "5"
}

export enum FormMeetingAction{
    ADD = "1",
    CHANGE = "2",
    COPY = "3",
    EXECUTE = "4",
    VIEW = "5",
    REOPEN = "6"
}

export interface IGrouperFilter extends IComponentButton{
    isActive:boolean;
}

export interface IGrouperOfMeetings{
    grouper: IGroupersMeeting;
    filters: IFiltersMeetingPanel;
    groupersSelect: MeetingGroupers;
    layoutList: "list" | "card";
    loadGroupers: Function;
    modalRef:RefObject<IRefModalFormMeeting>
}

export interface IListOfMeetings{
    data:Array<IMeetingListDTO>;
    callBackFunction:Function;
    options: (row: any) => ReactNode;
    layout?: "table" | undefined;
    origin?: "dashboard" | undefined;
}

export interface ICardOfMeetings{
    data:IMeetingListDTO;
    callBackFunction:Function;
    options: (row: any) => ReactNode;
}

export interface IRefModalDeleteMeeting {
    actionButtonDelete: (row:IMeetingListDTO,onClose?:()=>void) => void;
}

export interface IRefModalParticipantAttend {
    actionButtonOpen: (id:number,onClose?:()=>void) => void;
}

export interface IRefModalFormMeeting {
    actionButtonAdd: (onClose?:(row?:IMeetingFormDTO)=>void) => void;
    actionButtonRequest: (id:number,action:FormMeetingAction,onClose?:(row?:IMeetingFormDTO)=>void) => void;
}
